<template>
  <v-btn
    class="ma-1"
    v-bind="computedProps"
    v-on="$listeners"
  >
    <v-icon small>{{ icon }}</v-icon>
    <div>
      <slot></slot>
    </div>
  </v-btn>
</template>

<script>
import { VBtn } from "vuetify/lib";
export default {
  name: "SButton",
  extends: VBtn,
  props: {
    color: {
      type: String,
      default: "primaryColor",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedProps() {
      return {
        ...this.$props,
        color: this.color + " white--text",
        icon: false,
      };
    },
  },
};
</script>

<style></style>
